export function validateMinValue(minValue: number, message: string) {
	return {
		min: {
			value: minValue,
			message,
		},
	};
}
